import React, { useContext, useEffect, useState } from 'react';
import {
  PatientScreenerSuccess,
  SCREENER_STATUSES,
} from '../../../../shared/components/PatientScreener';
import { SchedulingSessionStateContext } from '../../../../shared/components/SchedulingSessionState';

export default function ScreenerSuccess() {
  const [showScreenerSuccess, setShowScreenerSuccess] = useState(false);
  const { screenerStatus } = useContext(SchedulingSessionStateContext);

  useEffect(() => {
    if (screenerStatus === SCREENER_STATUSES.PASSED) {
      setShowScreenerSuccess(true);
    }
  }, [screenerStatus]);

  if (!showScreenerSuccess) return null;

  return (
    <PatientScreenerSuccess
      onClose={() => {
        setShowScreenerSuccess(false);
      }}
    />
  );
}
